<template>
  <div class="container-flex fill-flex-full">
    <global-error v-if="globalError" />
    <div v-else class="container-right container-flex fill-flex-full">
      <div class="container-flex fill-flex-full">
        <div class="pay container-flex fill-flex-full">
          <div class="container-fluid container-flex fill-flex-full bg-white">
            <div class="container-wide container-flex fill-flex-full">
              <div class="spacer-75"></div>

              <div class="spacer-40"></div>
              <div class="row px-dynamic">
                <div class="col h1-rem">Оплата</div>
              </div>
              <div class="row px-dynamic">
                <div class="col h2-rem">
                  лицевого счета {{ this.$route.query.clnum }} по договору №{{
                    decodeURIComponent(this.$route.query.contract)
                  }}
                </div>
              </div>
              <div class="row px-dynamic">
                <div class="col h2-rem">
                  {{ this.$route.params.client }}
                </div>
              </div>

              <div class="row px-dynamic">
                <div class="col h2-rem">
                  Рекомендовано оплатить в {{ currentMonth.month }}:
                  {{
                    client.clientGroup[0].contracts[0]
                      .recommendedPaymentSumThisMonth ?? 0
                  }}&nbsp;₽
                </div>
              </div>
              <div class="row px-dynamic">
                <div class="col h2-rem">
                  Уже оплачено:
                  {{
                    client.clientGroup[0].contracts[0].paymentSumThisMonthNew
                  }}&nbsp;₽
                </div>
              </div>
              <div class="row px-dynamic">
                <div class="col h2-rem">
                  Осталось оплатить: {{ remainingPayment.toFixed(2) }}&nbsp;₽
                </div>
              </div>
              <div class="row px-dynamic h4-rem mt-2">
                <div class="col d-flex align-items-center">
                  <input
                    type="checkbox"
                    class="checkbox"
                    id="advance_payment"
                    v-model="advancePayment"
                  />
                  <label for="advance_payment" class="ml-2"></label>
                  <label for="advance_payment" class="ml-2"
                    >Оплатить с учетом аванса за {{ nextMonth.month }}</label
                  >
                </div>
              </div>
              <div class="spacer-40" />
              <form class="pay row px-dynamic" @submit.prevent="pay">
                <template
                  v-if="
                    this.client.sbpVisible ||
                    this.client.payTypes.filter((item) => item === 'sber25-sbp')
                      .length > 0
                  "
                >
                  <div class="col-4">
                    <input
                      type="radio"
                      class="radio"
                      id="pay-type-sbp"
                      :checked="method == 'sber25-sbp'"
                      @change="method = 'sber25-sbp'"
                    />
                    <label for="pay-type-sbp"
                      ><span class="text-nowrap">Система быстрых платежей</span>
                    </label>
                    <div
                      class="col-12 pt-3 pb-3 flex-wrap"
                      @click="method = 'sber25-sbp'"
                    >
                      <img
                        src="../assets/img/pay_sbp_no_text.svg"
                        width="110"
                        alt="sber25-sbp"
                      />
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    this.client.yookassaVisible ||
                    this.client.payTypes.filter((item) => item === 'yookassa')
                      .length > 0
                  "
                >
                  <div class="col-4">
                    <input
                      type="radio"
                      class="radio"
                      id="pay-type-yookassa"
                      :checked="method == 'yookassa'"
                      @change="method = 'yookassa'"
                    />
                    <label for="pay-type-yookassa">
                      <span class="text-nowrap">Сервис ЮKassa</span>
                    </label>
                    <div
                      class="col-12 pt-3 pb-3 flex-wrap"
                      @click="method = 'yookassa'"
                    >
                      <img
                        src="../assets/img/pay_yookassa.svg"
                        width="160"
                        alt="yookassa"
                      />
                    </div>
                  </div>
                </template>

                <template
                  v-if="
                    this.client.robokassaVisible ||
                    this.client.payTypes.filter((item) => item === 'robokassa')
                      .length > 0
                  "
                >
                  <div class="col-4">
                    <input
                      type="radio"
                      class="radio"
                      id="pay-type-robokassa"
                      :checked="method == 'robokassa'"
                      @change="method = 'robokassa'"
                    />
                    <label for="pay-type-robokassa">
                      <span class="text-nowrap">Сервис Робокасса</span>
                    </label>
                    <div
                      class="col-12 pt-3 pb-3 flex-wrap"
                      @click="method = 'robokassa'"
                    >
                      <img src="../assets/img/pay_robokassa.svg" width="220" />
                    </div>
                  </div>
                </template>
                <!-- <div class="col-12 pt-3 pb-4 flex-wrap">
                  <img src="../assets/img/pay_visa.png" width="70" />
                  <img src="../assets/img/pay_mastercard.png" width="70" />
                  <img src="../assets/img/pay_mir.png" width="70" />
                </div> -->
                <div class="spacer-40" />
                <div class="col-12 col-md-3 my-2 pr-md-3">
                  <input
                    type="text"
                    v-model="totalPayment"
                    class="input-text"
                    placeholder="Сумма платежа"
                  />
                </div>
                <div class="col-12 col-md-3 my-2 pr-md-3">
                  <a @click="pay" class="btn btn-blue" type="button"
                    >Оплатить</a
                  >
                </div>
                <div class="col-12 col-md-3 my-2 pr-md-3">
                  <a @click="getInvoice" class="btn btn-blue" type="button"
                    >Выставить счет</a
                  >
                </div>
                <div class="col-12 col-md-6"></div>
                <div v-if="error" class="col-12">
                  <div style="color: red">{{ error }}</div>
                </div>
              </form>

              <div class="fill-flex-full"></div>
              <div class="spacer-75"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="qrDialog"
      ref="qrDialog"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="qrCodeModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">QR-код для оплаты</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Закрыть"
              @click.stop.prevent="qrDialogCloseClick"
            ></button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-center align-items-center">
              <img v-if="qrId" :src="qrUrl" class="sbp-qr-code" />
            </div>
            <div
              class="d-flex justify-content-center align-items-center center pt-3"
            >
              <button class="btn-link" @click="openQrCode">
                Открыть ссылку для оплаты
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-12 col-md-6 p-2">
                <lk-button value="Закрыть" @click="qrDialogCloseClick" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import GlobalError from "./GlobalError.vue";
import moment from "moment";
import numeral from "numeral";
import config from "@/config";
import $ from "jquery";
import "numeral/locales";
import QRCodeStyling from "qr-code-styling";
import sbpLogoImg from "@/assets/img/pay_sbp_no_text.svg";
import utils from "@/utils";

export default {
  components: {
    GlobalError,
  },
  computed: {
    ...mapState([
      "globalError",
      "baseUrl",
      "paySuccess",
      "payError",
      "paymentUrl",
      "invoiceSuccess",
      "invoiceError",
      "qrId",
    ]),

    ...mapGetters([
      "client",
      "sumCurrentPayments",
      "remainingPayment",
      "sumNextPayments",
    ]),

    redirectUrl() {
      return location.protocol + "//" + location.host + "/#/";
    },

    currency(v, { withPlus, withLabel } = {}) {
      let res = numeral(v).format("0.00");
      if (withLabel) {
        res += "\u00A0" + "₽";
      }
      if (withPlus && /^\d+$/.test(res.charAt(0)) && v !== 0) {
        res = "+" + res;
      }
      return res;
    },

    qrUrlFromSbp() {
      return `${config.api.url}/sber25-sbp/qr/${this.qrId}${
        this.$store.getters.debug ? "/debug" : ""
      }`;
    },

    currentMonth() {
      const now = new Date();
      return utils.getMonth(now, 1);
    },

    nextMonth() {
      const now = new Date();
      now.setMonth(now.getMonth() + 1);
      return utils.getMonth(now);
    },
  },

  watch: {
    advancePayment() {
      let sum = this.remainingPayment;
      if (this.advancePayment) {
        sum += this.sumNextPayments;
      }
      sum = sum.toFixed(2);
      this.totalPayment = sum;
    },
  },

  data() {
    return {
      balance: 0,
      totalPayment: 0,
      error: null,
      time: null,
      method: "sber25-sbp",
      qrData: null,
      qrUrl: null,
      advancePayment: true,
    };
  },
  async created() {
    if (this.client === null) {
      await this.fetchClient();
    }

    //this.method = this.client.sbpVisible ? "sber25-sbp" : "sberbank";
    if (this.client.billing.paymentSum) {
      const currentClient = this.client.clientGroup.filter(
        (c) => c.clientId == this.$route.query.clnum,
      )[0];

      this.balance =
        currentClient.contracts.length > 1
          ? currentClient.contracts.reduce(
              (acc, currentContract) =>
                acc +
                (currentContract.balance === null ||
                currentContract.balance === undefined
                  ? 0
                  : currentContract.balance),
              0,
            )
          : currentClient.contracts[0].balance;

      // const advance =
      //   currentClient.contracts.length > 1
      //     ? currentClient.contracts.reduce(
      //         (acc, currentContract) =>
      //           acc +
      //           (currentContract.advance === null ||
      //           currentContract.advance === undefined
      //             ? 0
      //             : currentContract.advance),
      //         0
      //       )
      //     : currentClient.contracts[0].advance;
      // this.sum = this.balance < 0 ? this.balance * -1 : 0;
      // this.sum += advance
      let sum = this.remainingPayment;
      if (this.advancePayment) {
        sum += this.sumNextPayments;
      }
      sum = sum.toFixed(2);
      this.totalPayment = sum;
    }
    this.updateTime();
  },

  methods: {
    ...mapActions(["paymentPrepare", "downloadInvoice", "fetchClient"]),

    updateTime() {
      this.time = Number("" + moment());
    },
    pay() {
      const defaultErrorMessage = "Сервис временно недоступен";

      this.error = null;
      const sum = Number(("" + this.totalPayment).replace(",", "."));
      if (isNaN(sum)) {
        this.error = "Cумма к оплате указана неверно";
        return null;
      }

      if (sum <= 0) {
        this.error = "Сумма к оплате должна быть больше нуля";
        return null;
      }

      // const redirectUrl = `${this.redirectUrl}${
      //   this.redirectUrl.indexOf("?") >= 0 ? "&" : "?"
      // }system=${this.method}`;
      // console.log(`redirectUrl = ${redirectUrl}`)
      this.paymentPrepare({
        system: this.method,
        redirectUrl: this.redirectUrl,
        clnum: this.$route.query.clnum,
        contract: decodeURIComponent(this.$route.query.contract),
        sum: sum,
      }).then(() => {
        if (this.paySuccess) {
          if (!this.paymentUrl) {
            this.error = defaultErrorMessage;
            return null;
          }
          if (this.method === "sber25-sbp") {
            this.qrData = this.paymentUrl;

            const qrCode = new QRCodeStyling({
              width: 300,
              height: 300,
              type: "svg",
              data: this.qrData,
              image: sbpLogoImg,
              imageOptions: {
                crossOrigin: "anonymous",
                margin: 7,
              },
            });
            this.qrUrl = null;
            qrCode.getRawData("svg").then(async (x) => {
              this.qrUrl = URL.createObjectURL(x);
              $("#qrDialog").modal("show");
            });
            return;
          }
          window.location.href = this.paymentUrl;
        } else {
          this.error = this.payError || defaultErrorMessage;
        }
      });
      return false;
    },

    qrDialogCloseClick() {
      $("#qrDialog").modal("hide");
      try {
        return URL.revokeObjectURL(this.qrUrl);
      } catch (e) {
        return null;
      }
    },
    openQrCode() {
      window.open(this.qrData, "_self");
    },

    getInvoice() {
      const defaultErrorMessage = "Произошла ошибка при формировании счета";
      const sum = Number(("" + this.totalPayment).replace(",", "."));
      if (isNaN(sum)) {
        this.error = "Cумма к оплате указана неверно";
        return null;
      }

      if (sum <= 0) {
        this.error = "Сумма к оплате должна быть больше нуля";
        return null;
      }
      this.downloadInvoice({
        clnum: parseInt(this.$route.query.clnum),
        advance: sum,
      }).then(() => {
        if (!this.invoiceSuccess) {
          this.error = this.invoiceError || defaultErrorMessage;
        } else {
          this.error = null;
        }
      });
    },
  },
};
</script>
